/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface Res {
  data: {
    data: any;
    [key: string]: any;
  };
}

interface Params {
  [key: string]: any;
}

export const insightsActions = {
  getInsights,
  addInsight,
  updateInsight,
  deleteInsight,
};

function unwrap(promise: any, context: string): any {
  if (promise && 'data' in promise) return promise.data;
  console.log(`error in actions ${context}`);
  return Promise.reject(`Error: ${context}`);
}

function getInsights(): Promise<any> {
  return services
    .get<Res>(`/insights/list?status=all&limit=500`)
    .then((p) => unwrap(p, 'get insights'));
}

function addInsight(params: Params): Promise<any> {
  return services.post<Res>(`/insights/add`, params).then((p) => unwrap(p, 'add insight'));
}

function updateInsight(id: string | number, params: Params): Promise<any> {
  return services
    .put<Res>(`/insights/update/${id}`, params)
    .then((p) => unwrap(p, 'update insight'));
}

function deleteInsight(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/insights/delete/${id}`)
    .then((p) => unwrap(p, 'delete insight'));
}
